import React from "react";
import { Checkbox } from "../ui/checkbox";

export default function Terms({ termsAgreed, onTermsAgreedChange, onNext }) {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-text-primary mb-4">Terms & Conditions</h2>
            
            <div className="prose prose-invert max-w-none text-text-primary space-y-4">
                <div className="bg-tertiary rounded-lg p-6 border border-border">
                    <h3 className="text-xl font-semibold mb-3 text-text-primary">Purpose</h3>
                    <p className="text-text-secondary">Assembly platform exists to unite the body of Christ.</p>
                </div>

                <div className="bg-tertiary rounded-lg p-6 border border-border">
                    <h3 className="text-xl font-semibold mb-3 text-text-primary">Terms</h3>
                    <ul className="list-disc list-inside space-y-2 text-text-secondary">
                        <li>This is a platform for connection and collaboration, not division</li>
                        <li>All organizations on Assembly Platform are expected to adhere to Christian principles of love, respect, and truth.</li>
                        <li>Organizations should not be used to impersonate individuals or groups, or to misrepresent affiliation.</li>
                        <li>By creating an organization, you acknowledge that you are responsible for its content and activity.</li>
                        <li>Assembly Platform reserves the right to remove organizations that violate these terms.</li>
                    </ul>
                </div>

                <div className="bg-tertiary rounded-lg p-6 border border-border">
                    <h3 className="text-xl font-semibold mb-3 text-text-primary">Account Verification</h3>
                    <p className="text-text-secondary mb-2">
                        Organizations and independent ministry leaders on Assembly undergo a verification process to confirm authenticity. Verification includes manual review of this application.
                    </p>
                    <p className="text-text-secondary">
                        Staff invited by a verified organization are considered verified through that organization. It is the organization&apos;s responsibility to ensure the authenticity of staff accounts.
                    </p>
                </div>

                <div className="bg-tertiary rounded-lg p-6 border border-border">
                    <h3 className="text-xl font-semibold mb-3 text-text-primary">Staff accountability</h3>
                    <p className="text-text-secondary">
                        The organization will be held accountable for the actions and conduct of its staff on the platform. If a verified staff member violates community standards or these terms, the organization itself may face warnings, suspension, or removal from Assembly.
                    </p>
                </div>
            </div>

            <div className="flex items-start space-x-3 pt-4 border-t border-border">
                <Checkbox
                    id="terms-agreement"
                    checked={termsAgreed}
                    onCheckedChange={onTermsAgreedChange}
                    className="mt-1 h-5 w-5"
                />
                <label htmlFor="terms-agreement" className="text-text-secondary">
                    By proceeding, you confirm that you have read, understood, and agree to abide by these terms.
                </label>
            </div>

            <div className="flex justify-end pt-4">
                <button
                    onClick={onNext}
                    disabled={!termsAgreed}
                    className={`
                        px-6 py-2 rounded-md font-semibold transition
                        ${termsAgreed
                            ? "bg-accent text-text-on-accent hover:bg-accent-hover cursor-pointer"
                            : "bg-secondary text-text-secondary cursor-not-allowed opacity-50"
                        }
                    `}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

